const LANGUAGE_LIST = [
    'afrikaans',
    'albanian',
    'amharic',
    'arabic',
    'armenian',
    'assamese',
    'azerbaijani',
    'bashkir',
    'basque',
    'belarusian',
    'bengali',
    'bosnian',
    'breton',
    'bulgarian',
    'cantonese',
    'catalan',
    'chinese',
    'croatian',
    'czech',
    'danish',
    'dutch',
    'english',
    'estonian',
    'faroese',
    'finnish',
    'french',
    'galician',
    'georgian',
    'german',
    'greek',
    'gujarati',
    'haitian creole',
    'hausa',
    'hawaiian',
    'hebrew',
    'hindi',
    'hungarian',
    'icelandic',
    'indonesian',
    'italian',
    'japanese',
    'javanese',
    'kannada',
    'kazakh',
    'khmer',
    'korean',
    'lao',
    'latin',
    'latvian',
    'lingala',
    'lithuanian',
    'luxembourgish',
    'macedonian',
    'malagasy',
    'malay',
    'malayalam',
    'maltese',
    'maori',
    'marathi',
    'mongolian',
    'myanmar',
    'nepali',
    'norwegian',
    'nynorsk',
    'occitan',
    'pashto',
    'persian',
    'polish',
    'portuguese',
    'punjabi',
    'romanian',
    'russian',
    'sanskrit',
    'serbian',
    'shona',
    'sindhi',
    'sinhala',
    'slovak',
    'slovenian',
    'somali',
    'spanish',
    'sundanese',
    'swahili',
    'swedish',
    'tagalog',
    'tajik',
    'tamil',
    'tatar',
    'telugu',
    'thai',
    'tibetan',
    'turkish',
    'turkmen',
    'ukrainian',
    'urdu',
    'uzbek',
    'vietnamese',
    'welsh',
    'yiddish',
    'yoruba',
];

const LANGUAGE_MAP = {
    cn: 'chinese',
    tw: 'chinese',
    de: 'german',
    es: 'spanish',
    fr: 'french',
    jp: 'japanese',
    pt: 'portuguese',
};

const MODAL_PARTICLE = {
    chinese: [
        '哼',
        '呵',
        '呼',
        '欸',
        '哎',
        '啊',
        '唉',
        '哟',
        '嘿',
        '嚯',
        '哦',
        '吧',
        '呢',
        '啊',
        '啦',
        '呀',
        '的',
        '嘛',
        '么',
        '吗',
        '哇',
        '唉',
        '呗',
        '咦',
        '塞',
        '哟',
        '了',
        '切',
        '呸',
        '喂',
        '嘻',
        '呃',
        '嗯',
        '得',
        '啧',
        '噻',
        '咳',
        '哈',
        '嗯',
        '呃',
        '啊',
        '哎',
        '喔',
        '嘛',
        '啦',
        '囉',
        '咩',
        '喎',
        '哇',
        '呀',
        '唉',
        '嘿',
        '噢',
        '呵',
        '呼',
        '哼',
        '哦',
        '咦',
        '咯',
        '嘻',
        '哩',
        '吧',
        '吓',
        '唷',
        '嗨',
        '哎',
        '喂',
        '哉',
        '著',
        '呢',
        '嗎',
        '啵',
        '哪',
        '吼',
        '甭',
        '罷',
    ],
    english: [
        'Wow',
        'Oh',
        'Whoa',
        'Gosh',
        'Jeez',
        'Yay',
        'Hooray',
        'Woohoo',
        'Yippee',
        'Ugh',
        'Oof',
        'Meh',
        'Darn',
        'Um',
        'Uh',
        'Er',
        'Yeah',
        'Uh-huh',
        'Mm-hmm',
        'Nope',
        'Nah',
        'Ouch',
        'Eek',
        'Hmm',
        'Huh',
        'Umm',
        'Err',
        'Well',
        'So',
    ],
    spanish: [
        'Bueno',
        'Pues',
        'Este',
        'O',
        'Sí',
        'No',
        'Pero',
        'Porque',
        'Aunque',
        'Además',
        'Quizás',
        'Ya',
        'Todavía',
        'Solo',
        'Hasta',
        'Ahora',
        'Luego',
        'Mientras',
        'Entonces',
        'Verdaderamente',
        'Probablemente',
        'Definitivamente',
        'Realmente',
        '¡Guau',
        '¡Anda',
        '¡Olé',
        '¡Hala',
        '¡Ay',
        '¡Uf',
        '¡Uy',
        '¡Vale',
        '¡Dale',
        '¡Ándale',
        '¡Órale',
        '¡Ojo',
        '¡Cuidado',
        '¡Aguas',
        '¡Caramba',
        '¡Caray',
        '¡Recórcholis',
        '¡Córcholis',
    ],
    portuguese: [
        'Nossa',
        'Uau',
        'Eita',
        'Caramba',
        'Puxa',
        'Aff',
        'Credo',
        'Vixe',
        'Poxa',
        'Ai',
        'Ui',
        'Ufa',
        'Safa',
        'Vamos',
        'Força',
        'Coragem',
        'Hein',
        'Será',
        'Ei',
        'Psiu',
        'Tomara',
        'Oxalá',
        'Nossa',
        'Sim',
        'Não',
        'Talvez',
        'Claro',
        'Provavelmente',
        'Possivelmente',
        'Definitivamente',
        'Certamente',
        'Absolutamente',
        'Realmente',
        'Infelizmente',
        'Felizmente',
        'Aparentemente',
        'Obviamente',
    ],
    french: [
        'Ah',
        'Oh',
        'Aïe',
        'Ouf',
        'Hélas',
        'Zut',
        'Bof',
        'Mince',
        'Chiche',
        'Hé',
        'Ohé',
        'Hop',
        'Allez',
        'Ouste',
        'Atchoum',
        'Boum',
        'Cocorico',
        'Miam',
        'Snif',
        'Alors',
        'Donc',
        'Quoi',
        'Daccord',
        'Si',
        'Mais',
    ],
    german: [
        'Ach',
        'Oh',
        'Aha',
        'Tja',
        'Oje',
        'Mensch',
        'Verdammt',
        'Hm',
        'Naja',
        'Super',
        'Spitze',
        'Na',
        'Also',
        'Lecker',
        'Igitt',
    ],
    japanese: [
        'よ',
        'ね',
        'か',
        'わ',
        'な',
        'なあ',
        'ぞ',
        'ぜ',
        'や',
        'かしら',
        'かな',
        'もの',
        'て',
        'で',
        'けれど',
        'けども',
        'え',
        'えい',
    ],
};

export { LANGUAGE_LIST, LANGUAGE_MAP, MODAL_PARTICLE };
